export const SHIPPING_RATE_LIST = 'SHIPPING_RATE_LIST';
export const SHIPPING_RATE_CREATE = 'SHIPPING_RATE_CREATE';
export const SHIPPING_RATE_DELETE = 'SHIPPING_RATE_DELETE';
export const SHIPPING_RATE_DETAIL_CREATE = 'SHIPPING_RATE_DETAIL_CREATE';
export const SHIPPING_RATE_DETAIL_UPDATE = 'SHIPPING_RATE_DETAIL_UPDATE';
export const SHIPPING_RATE_DETAIL_DELETE = 'SHIPPING_RATE_DETAIL_DELETE';
export const SHIPPING_RATE_GET_AVAILABLE = 'SHIPPING_RATE_GET_AVAILABLE';